import { HttpContextToken } from "@angular/common/http";

export const SKIP_AUTHENTICATION_HTTP_INTERCEPTOR = new HttpContextToken(() => true);
